import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { wedding as defaults } from "@/lib/weddingConfig";

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

function deepMerge(base, over) {
  if (!isObj(base) || !isObj(over)) return over === undefined ? base : over;
  const out = { ...base };
  for (const k of Object.keys(over)) {
    out[k] = isObj(base[k]) && isObj(over[k]) ? deepMerge(base[k], over[k]) : over[k];
  }
  return out;
}

const Ctx = createContext({ content: defaults, loaded: false, refresh: () => {}, defaults });

export function ContentProvider({ children }) {
  const [content, setContent] = useState(defaults);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      if (data && Object.keys(data).length) setContent(deepMerge(defaults, data));
    } catch {
      /* keep defaults */
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <Ctx.Provider value={{ content, loaded, refresh: load, defaults }}>{children}</Ctx.Provider>
  );
}

export const useContent = () => useContext(Ctx).content;
export const useContentRefresh = () => useContext(Ctx).refresh;
export const useContentLoaded = () => useContext(Ctx).loaded;
